import { FeatureCollection, Geometry } from "geojson";

export const Tipligheri: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.8955, 22.0955] },
      "properties": { "Type": "Camera", "Device_ID": "0011" }
    },
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.8905, 22.0910] },
      "properties": { "Type": "Camera", "Device_ID": "0012" }
    },
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.8950, 22.0920] },
      "properties": { "Type": "BioAcoustic", "Device_ID": "0021" }
    },
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.8870, 22.0885] },
      "properties": { "Type": "BioAcoustic", "Device_ID": "0022" }
    },

    {
      "type": "Feature",
      "properties": {
        "Name": "Tipligheri",
        "Type": "Restoration",
        "Area": "68.83 ha",
        "ID": "007"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              88.893753616285721,
              22.090771299971738
            ],
            [
              88.892096690929179,
              22.09036723096348
            ],
            [
              88.891510144088755,
              22.090171042725
            ],
            [
              88.890847638494236,
              22.089951196612301
            ],
            [
              88.890064737519808,
              22.089531875011009
            ],
            [
              88.889238800252514,
              22.089024107457121
            ],
            [
              88.888393516963347,
              22.088471126614341
            ],
            [
              88.887671654610898,
              22.08791210057144
            ],
            [
              88.886824360590481,
              22.08730409330914
            ],
            [
              88.886006372493213,
              22.086717108320212
            ],
            [
              88.885048772711798,
              22.086139925692731
            ],
            [
              88.884214457489236,
              22.08581947599663
            ],
            [
              88.883424241534499,
              22.085680396466941
            ],
            [
              88.882645820581004,
              22.085606762137999
            ],
            [
              88.881678032176183,
              22.085588348134781
            ],
            [
              88.880965138832863,
              22.085652548888351
            ],
            [
              88.880209106797778,
              22.08573555141065
            ],
            [
              88.879910543895818,
              22.085837741971851
            ],
            [
              88.880491565767912,
              22.085856461815549
            ],
            [
              88.881247357224908,
              22.08609205201482
            ],
            [
              88.881791669726823,
              22.086293030967479
            ],
            [
              88.882174391460325,
              22.086683943317439
            ],
            [
              88.882764850312299,
              22.086933873787181
            ],
            [
              88.883515294123242,
              22.087301587890099
            ],
            [
              88.884136638064447,
              22.087732017577061
            ],
            [
              88.885183340314853,
              22.088230412744242
            ],
            [
              88.886565079667349,
              22.088837450931148
            ],
            [
              88.887248444771572,
              22.08920891953084
            ],
            [
              88.888636005972543,
              22.08972257630705
            ],
            [
              88.890026223985089,
              22.090146881953771
            ],
            [
              88.890142252829165,
              22.090384956353301
            ],
            [
              88.890131814021558,
              22.090705541244741
            ],
            [
              88.889984859343087,
              22.09096334357514
            ],
            [
              88.889522117686099,
              22.091534886254951
            ],
            [
              88.889709922320421,
              22.091628887754041
            ],
            [
              88.889997967411063,
              22.091893211310971
            ],
            [
              88.890363151817397,
              22.092064906057661
            ],
            [
              88.890545684488714,
              22.092173233736158
            ],
            [
              88.890687882016351,
              22.09211897511398
            ],
            [
              88.890820720457214,
              22.09188256115322
            ],
            [
              88.89094267198476,
              22.091462220169149
            ],
            [
              88.891123815211131,
              22.091033579744671
            ],
            [
              88.891470446216616,
              22.09084380454091
            ],
            [
              88.892102582459358,
              22.090764659375491
            ],
            [
              88.892781779941018,
              22.090656547764809
            ],
            [
              88.893380601256112,
              22.090814104005311
            ],
            [
              88.893682271763652,
              22.091053751452961
            ],
            [
              88.893952012610086,
              22.091549887429661
            ],
            [
              88.894506262113666,
              22.093818374947858
            ],
            [
              88.894734664428867,
              22.094589597949501
            ],
            [
              88.894685298155849,
              22.09518716855618
            ],
            [
              88.894662694861154,
              22.09590996397786
            ],
            [
              88.894683907897445,
              22.096523432054319
            ],
            [
              88.894527571148757,
              22.096794537913681
            ],
            [
              88.894061928473519,
              22.09689314301383
            ],
            [
              88.893382447063544,
              22.0970895402107
            ],
            [
              88.892917524229489,
              22.097234864444498
            ],
            [
              88.892628833738598,
              22.097344709060351
            ],
            [
              88.892358546861658,
              22.097501589478309
            ],
            [
              88.892085166497026,
              22.097791552318281
            ],
            [
              88.891931862987889,
              22.09787668886074
            ],
            [
              88.891418784124909,
              22.09800998650713
            ],
            [
              88.890976386483786,
              22.098067435965682
            ],
            [
              88.890535825707971,
              22.098057838123541
            ],
            [
              88.890299987875636,
              22.098057833616569
            ],
            [
              88.890042132844201,
              22.098240975552841
            ],
            [
              88.889986208000579,
              22.098465366038031
            ],
            [
              88.889951678702374,
              22.098832662031072
            ],
            [
              88.889731738721878,
              22.09897371138868
            ],
            [
              88.889409022340828,
              22.099187468497
            ],
            [
              88.889024062345896,
              22.0998130589246
            ],
            [
              88.888714835156179,
              22.100783655396452
            ],
            [
              88.888686774870237,
              22.101191559598409
            ],
            [
              88.888709816127658,
              22.101904042008091
            ],
            [
              88.888829325446011,
              22.102434839832839
            ],
            [
              88.88914973236308,
              22.103204154573351
            ],
            [
              88.889697292343399,
              22.104028451526499
            ],
            [
              88.890181542248541,
              22.10512298607583
            ],
            [
              88.890421147917507,
              22.106047945526079
            ],
            [
              88.89049560889373,
              22.107049034476969
            ],
            [
              88.890266332344567,
              22.10861276568259
            ],
            [
              88.8902629844941,
              22.109460967181612
            ],
            [
              88.890008971234025,
              22.11020594292491
            ],
            [
              88.889946562309987,
              22.11082153187332
            ],
            [
              88.890257572681548,
              22.11163031467532
            ],
            [
              88.890507049126612,
              22.112724416003029
            ],
            [
              88.890729895338225,
              22.113498474238732
            ],
            [
              88.890922182539967,
              22.113981872795438
            ],
            [
              88.891224784330078,
              22.1148340505584
            ],
            [
              88.891303719888867,
              22.11568746327017
            ],
            [
              88.891135349959185,
              22.11621457609683
            ],
            [
              88.890544186022211,
              22.11710212704925
            ],
            [
              88.889770796689234,
              22.11798774091239
            ],
            [
              88.888488781989878,
              22.119365864569971
            ],
            [
              88.887994200508189,
              22.119768172047301
            ],
            [
              88.887677604019061,
              22.119768164417149
            ],
            [
              88.887310381059379,
              22.120531850066659
            ],
            [
              88.887277902265737,
              22.1210630163635
            ],
            [
              88.887207323955153,
              22.12143090367443
            ],
            [
              88.886941654330172,
              22.121942211328921
            ],
            [
              88.886640127346823,
              22.122281914558378
            ],
            [
              88.886364505240493,
              22.1224983539825
            ],
            [
              88.885935370626584,
              22.122753357499281
            ],
            [
              88.885504388216418,
              22.12270020813331
            ],
            [
              88.88498806213741,
              22.122489558942661
            ],
            [
              88.884592023752404,
              22.122026349461191
            ],
            [
              88.884075189439272,
              22.12143081757505
            ],
            [
              88.883515332508878,
              22.1206276324166
            ],
            [
              88.88297417319248,
              22.119955544171042
            ],
            [
              88.883186960836184,
              22.12040745045806
            ],
            [
              88.883598322476743,
              22.121198740449518
            ],
            [
              88.883859467073151,
              22.121896811005811
            ],
            [
              88.884086621457271,
              22.122357137823631
            ],
            [
              88.88424789910583,
              22.122707479532082
            ],
            [
              88.884501761708492,
              22.123082244734899
            ],
            [
              88.884666986690164,
              22.12341287379563
            ],
            [
              88.884983719382433,
              22.123640359663309
            ],
            [
              88.885381989584516,
              22.123871574976452
            ],
            [
              88.885771403362597,
              22.12399266610009
            ],
            [
              88.88624745904248,
              22.124033266732621
            ],
            [
              88.88669780270331,
              22.123952210934561
            ],
            [
              88.887267302597735,
              22.12371971103029
            ],
            [
              88.887770384709555,
              22.123428514768321
            ],
            [
              88.888259597527309,
              22.12285768031893
            ],
            [
              88.888596329218799,
              22.12243742800878
            ],
            [
              88.889057844626279,
              22.12150131898051
            ],
            [
              88.889416063770099,
              22.120727228937401
            ],
            [
              88.889498001751392,
              22.12046948598908
            ],
            [
              88.889829679732514,
              22.119830199737809
            ],
            [
              88.890681664759398,
              22.118520420200511
            ],
            [
              88.89139345368163,
              22.117586701707442
            ],
            [
              88.891985215903773,
              22.11657776359807
            ],
            [
              88.89220351404164,
              22.115784530532551
            ],
            [
              88.892345698821487,
              22.11479867948988
            ],
            [
              88.892288754623166,
              22.113869566557991
            ],
            [
              88.892018983780602,
              22.112518451070908
            ],
            [
              88.891722095176746,
              22.110595808454619
            ],
            [
              88.891551322014593,
              22.108955480347149
            ],
            [
              88.891382598616374,
              22.1075534610336
            ],
            [
              88.891244215963738,
              22.106717026357192
            ],
            [
              88.890947997389631,
              22.105530763680711
            ],
            [
              88.89033769126344,
              22.104048447965379
            ],
            [
              88.889853524664005,
              22.10305848526232
            ],
            [
              88.88950044528039,
              22.101970677412272
            ],
            [
              88.889354036320213,
              22.10113153943886
            ],
            [
              88.889449022524403,
              22.100526680421069
            ],
            [
              88.889632048462261,
              22.10007865346498
            ],
            [
              88.889766712100965,
              22.09980491279433
            ],
            [
              88.890227743345349,
              22.099129741453979
            ],
            [
              88.890673991660691,
              22.098746083782359
            ],
            [
              88.891525974036796,
              22.098267589243751
            ],
            [
              88.891983139409973,
              22.098042621897282
            ],
            [
              88.892596322154176,
              22.097836385981299
            ],
            [
              88.893320518200468,
              22.097633662136289
            ],
            [
              88.894117629358149,
              22.097427306569049
            ],
            [
              88.894724671809783,
              22.0971141605174
            ],
            [
              88.895100801541076,
              22.09679131807076
            ],
            [
              88.895281088729192,
              22.096601059132379
            ],
            [
              88.895451356703035,
              22.09641544343118
            ],
            [
              88.895581672785227,
              22.096160750183721
            ],
            [
              88.895696846145242,
              22.09584515487893
            ],
            [
              88.895786973026645,
              22.09552028768864
            ],
            [
              88.895842037877713,
              22.095186149569489
            ],
            [
              88.895872049251238,
              22.094722086421719
            ],
            [
              88.895831964806305,
              22.094490062875391
            ],
            [
              88.895841958276435,
              22.09420235949371
            ],
            [
              88.89583708257895,
              22.094005713475049
            ],
            [
              88.895807009873877,
              22.093755091608688
            ],
            [
              88.895796948321731,
              22.093216739629241
            ],
            [
              88.895791918960697,
              22.09295685559486
            ],
            [
              88.895761845344566,
              22.092650572239009
            ],
            [
              88.895751805577547,
              22.092344297250541
            ],
            [
              88.895706700436705,
              22.091903461929149
            ],
            [
              88.895656594369143,
              22.091522964980669
            ],
            [
              88.895581461488717,
              22.091300241286621
            ],
            [
              88.895491312111716,
              22.091161041664691
            ],
            [
              88.895275972721251,
              22.091086804725212
            ],
            [
              88.894960479538696,
              22.090998649118269
            ],
            [
              88.894715098421869,
              22.09094761210774
            ],
            [
              88.894379579432339,
              22.090873375814951
            ],
            [
              88.894064093268696,
              22.09083625783401
            ],
            [
              88.893753616285721,
              22.090771299971738
            ]
          ]
        ]
      }
    }
  ]
}

export const Maipith: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.5370, 21.8581] },
      "properties": { "Type": "Camera", "Device_ID": "0411" }
    },
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.5285, 21.8540] },
      "properties": { "Type": "Camera", "Device_ID": "0412" }
    },
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.5375, 21.8609] },
      "properties": { "Type": "BioAcoustic", "Device_ID": "0421" }
    },
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.5353, 21.8655] },
      "properties": { "Type": "BioAcoustic", "Device_ID": "0422" }
    },
    {
      "type": "Feature",
      "properties": {
        "Name": "Maipith",
        "Type": "Restoration",
        "Area": "25.68 ha",
        "ID": "008"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              88.523596194472105,
              21.85521496987521
            ],
            [
              88.526194982360067,
              21.854430936335909
            ],
            [
              88.526413445093553,
              21.854417581351491
            ],
            [
              88.526647613018653,
              21.854704732275302
            ],
            [
              88.526894046198649,
              21.85507319934533
            ],
            [
              88.527166909851488,
              21.855493064910569
            ],
            [
              88.52747662664575,
              21.855281900900319
            ],
            [
              88.527779284421641,
              21.855089530755691
            ],
            [
              88.528051942295576,
              21.854965759231291
            ],
            [
              88.528364982787878,
              21.85495181368222
            ],
            [
              88.52864507665133,
              21.854945164017721
            ],
            [
              88.528913084721481,
              21.855003836568141
            ],
            [
              88.529334666493028,
              21.855121940634039
            ],
            [
              88.529766186417405,
              21.85525629528869
            ],
            [
              88.530155120007834,
              21.855377147811321
            ],
            [
              88.530457254712175,
              21.855483936416519
            ],
            [
              88.530507053735306,
              21.855653110712801
            ],
            [
              88.530989152995957,
              21.85573952495298
            ],
            [
              88.531529363704223,
              21.85592154690735
            ],
            [
              88.532569979347116,
              21.856229205217769
            ],
            [
              88.53319439202032,
              21.856402983034659
            ],
            [
              88.533625703291747,
              21.856428647998381
            ],
            [
              88.533949210673839,
              21.856387798192429
            ],
            [
              88.534740683113625,
              21.85658954301762
            ],
            [
              88.535354534047627,
              21.856798221778259
            ],
            [
              88.535340612815347,
              21.857012102329321
            ],
            [
              88.535399280574197,
              21.857134850888059
            ],
            [
              88.535841350398101,
              21.857362032339442
            ],
            [
              88.536416834898333,
              21.857720626547781
            ],
            [
              88.53670655153276,
              21.858281909114439
            ],
            [
              88.537049561276717,
              21.858881196848309
            ],
            [
              88.537258068498133,
              21.85942837733246
            ],
            [
              88.537617628805094,
              21.86013282580927
            ],
            [
              88.537583098525317,
              21.860303087140149
            ],
            [
              88.537499337063039,
              21.860450659727711
            ],
            [
              88.537323734181527,
              21.860693884688772
            ],
            [
              88.537184123179529,
              21.861161523300609
            ],
            [
              88.537359891653423,
              21.86182953210816
            ],
            [
              88.537651955965984,
              21.862323997603919
            ],
            [
              88.537816567767138,
              21.862894461604679
            ],
            [
              88.537643474365737,
              21.863042058292042
            ],
            [
              88.537497992519391,
              21.86327402900698
            ],
            [
              88.537566394791696,
              21.863540796645172
            ],
            [
              88.537215280497577,
              21.863611119636431
            ],
            [
              88.536891366647879,
              21.863748266844208
            ],
            [
              88.536465201481477,
              21.863935365052559
            ],
            [
              88.536161334723346,
              21.864205999822481
            ],
            [
              88.535865202292271,
              21.864494762401879
            ],
            [
              88.535489845495178,
              21.864621720285989
            ],
            [
              88.535398530397842,
              21.865011688906829
            ],
            [
              88.535160708633782,
              21.865351448226669
            ],
            [
              88.534788218542246,
              21.865737259402799
            ],
            [
              88.53435089224979,
              21.86617561360061
            ],
            [
              88.533747339620945,
              21.86677058957909
            ],
            [
              88.533126407436413,
              21.86732100271216
            ],
            [
              88.532428045761293,
              21.867967900443009
            ],
            [
              88.531800206798934,
              21.868652446301191
            ],
            [
              88.531390143447339,
              21.869204473882391
            ],
            [
              88.5310112834959,
              21.869857420452341
            ],
            [
              88.530715105960354,
              21.87066148898295
            ],
            [
              88.530387530145703,
              21.871324999145379
            ],
            [
              88.530167430363079,
              21.871331507343442
            ],
            [
              88.530006393439336,
              21.87141468282859
            ],
            [
              88.529955866648223,
              21.871569924054249
            ],
            [
              88.530073455458535,
              21.871525879471541
            ],
            [
              88.530312400594838,
              21.87159284640282
            ],
            [
              88.530655058822205,
              21.871696644948621
            ],
            [
              88.530972263747032,
              21.87179267598416
            ],
            [
              88.531072864099357,
              21.871536642102871
            ],
            [
              88.531251095175946,
              21.87055463925072
            ],
            [
              88.53184577483799,
              21.86950160081193
            ],
            [
              88.532566675056515,
              21.868540547358869
            ],
            [
              88.533505239068589,
              21.867847301267538
            ],
            [
              88.534197769697286,
              21.86731066792861
            ],
            [
              88.535024218395705,
              21.866578966723029
            ],
            [
              88.535727616831281,
              21.86584588689546
            ],
            [
              88.536354828906141,
              21.865127324134399
            ],
            [
              88.536564438031121,
              21.864664559920129
            ],
            [
              88.536844718052606,
              21.864250482465991
            ],
            [
              88.536983809924223,
              21.864040711794061
            ],
            [
              88.537251818127558,
              21.863829669940671
            ],
            [
              88.537848131327351,
              21.863780004033121
            ],
            [
              88.538640030942204,
              21.863821025726359
            ],
            [
              88.53875187689556,
              21.863797634128112
            ],
            [
              88.538892991704813,
              21.863422800765179
            ],
            [
              88.538990105219,
              21.86277424398487
            ],
            [
              88.538835922810321,
              21.861753685907711
            ],
            [
              88.53865936794908,
              21.860996580348871
            ],
            [
              88.538043734818714,
              21.85939144347007
            ],
            [
              88.537703612516623,
              21.858691821280551
            ],
            [
              88.537004368940543,
              21.85770027991628
            ],
            [
              88.536263228389913,
              21.85709404949792
            ],
            [
              88.535540368993921,
              21.856752120834081
            ],
            [
              88.535155982987803,
              21.85656506736002
            ],
            [
              88.534668475151378,
              21.856397383708121
            ],
            [
              88.534256382245943,
              21.856256774196019
            ],
            [
              88.533763640936741,
              21.856150092550511
            ],
            [
              88.533321795107128,
              21.8561008010014
            ],
            [
              88.532829194419307,
              21.855987575356721
            ],
            [
              88.532220433234542,
              21.855835820027369
            ],
            [
              88.531255427114942,
              21.855485345133371
            ],
            [
              88.530754330880185,
              21.85520591049632
            ],
            [
              88.530413223163933,
              21.855021127673371
            ],
            [
              88.529884654596486,
              21.854654171126999
            ],
            [
              88.52931498861345,
              21.854191147992541
            ],
            [
              88.528660157605415,
              21.853443134236539
            ],
            [
              88.528103597721426,
              21.85256385325944
            ],
            [
              88.527787894777802,
              21.852852990411801
            ],
            [
              88.527425582334359,
              21.853120858174812
            ],
            [
              88.526880725318136,
              21.853464836515119
            ],
            [
              88.526391692841415,
              21.853718022662179
            ],
            [
              88.526071521665131,
              21.853833933178951
            ],
            [
              88.525808670712422,
              21.853833439781809
            ],
            [
              88.52495304966881,
              21.854318733804991
            ],
            [
              88.523596194472105,
              21.85521496987521
            ]
          ]
        ]
      }
    }
  ]
}

export const Dwariknagar: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.2866, 21.7200] },
      "properties": { "Type": "Camera", "Device_ID": "0611" }
    },
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.2840, 21.7260] },
      "properties": { "Type": "Camera", "Device_ID": "0612" }
    },
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.2855, 21.7205] },
      "properties": { "Type": "BioAcoustic", "Device_ID": "0621" }
    },
    {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [88.2815, 21.7280] },
      "properties": { "Type": "BioAcoustic", "Device_ID": "0622" }
    },
    {
      "type": "Feature",
      "properties": { "Name": "Dwariknagar", "Type": "Restoration", "Area": "66.04 ha", "ID": "002" },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[88.289834420687797, 21.7153804925366], [88.288597831237894, 21.715002435280901], [88.286769478815103, 21.718007222690201], [88.285946087869803, 21.7192344892782], [88.285374263436594, 21.720198568102301], [88.284982216092502, 21.721019473213399], [88.283760150619202, 21.7229507351467], [88.283059305869202, 21.724063954391902], [88.281861683864193, 21.725382158715401], [88.279615183214801, 21.727418545197299], [88.278426943840401, 21.7280852832804], [88.276240134734394, 21.731269108699198], [88.275377075600304, 21.733233260241999], [88.275053387726302, 21.734716416149599], [88.278139728708595, 21.733550437129399], [88.282113418374195, 21.727882598231702], [88.285349747274296, 21.725517269560399], [88.287922812176603, 21.7216224104227], [88.288719001235805, 21.719035005751099], [88.289549327356696, 21.71680195783], [88.289834420687797, 21.7153804925366]]]
      }
    }
  ]
}

export const DashMarkers: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          88.28292891927941,
          21.725725723732452
        ],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          88.5383020887142,
          21.86084566864031
        ],
        "type": "Point"
      }
    },
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          88.89079579142646,
          22.10739348062593
        ],
        "type": "Point"
      }
    }
  ]
}




export const MER_CR_Demarcation2025: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "Name": "Mer"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              95.4897682,
              27.8569751,
              0
            ],
            [
              95.4898577,
              27.8576576,
              0
            ],
            [
              95.4894162,
              27.8578582,
              0
            ],
            [
              95.4881002,
              27.858297,
              0
            ],
            [
              95.4870678,
              27.8584223,
              0
            ],
            [
              95.4859837,
              27.8586033,
              0
            ],
            [
              95.4846682,
              27.8588833,
              0
            ],
            [
              95.4841716,
              27.8587311,
              0
            ],
            [
              95.4826177,
              27.8593029,
              0
            ],
            [
              95.4802138,
              27.8596619,
              0
            ],
            [
              95.4795683,
              27.8593951,
              0
            ],
            [
              95.479341,
              27.8589989,
              0
            ],
            [
              95.479131,
              27.8586144,
              0
            ],
            [
              95.4788595,
              27.858188,
              0
            ],
            [
              95.4787518,
              27.857611,
              0
            ],
            [
              95.4787518,
              27.857611,
              0
            ],
            [
              95.4786703,
              27.856994,
              0
            ],
            [
              95.4784425,
              27.8564606,
              0
            ],
            [
              95.4783379,
              27.8558474,
              0
            ],
            [
              95.4783538,
              27.8552503,
              0
            ],
            [
              95.4792168,
              27.8549193,
              0
            ],
            [
              95.4801348,
              27.8544914,
              0
            ],
            [
              95.4808602,
              27.8540991,
              0
            ],
            [
              95.4823356,
              27.8534242,
              0
            ],
            [
              95.4833298,
              27.8530834,
              0
            ],
            [
              95.4842492,
              27.8529778,
              0
            ],
            [
              95.4853782,
              27.8527406,
              0
            ],
            [
              95.4862998,
              27.8526044,
              0
            ],
            [
              95.4873911,
              27.8524241,
              0
            ],
            [
              95.4883721,
              27.852393,
              0
            ],
            [
              95.4894508,
              27.8520497,
              0
            ],
            [
              95.4902888,
              27.8518272,
              0
            ],
            [
              95.4908091,
              27.8523072,
              0
            ],
            [
              95.4916647,
              27.8526561,
              0
            ],
            [
              95.4919797,
              27.8536843,
              0
            ],
            [
              95.4920357,
              27.8540022,
              0
            ],
            [
              95.4917373,
              27.8546474,
              0
            ],
            [
              95.491566,
              27.8550414,
              0
            ],
            [
              95.4912559,
              27.8559909,
              0
            ],
            [
              95.4907453,
              27.8565191,
              0
            ],
            [
              95.4897682,
              27.8569751,
              0
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4851, 27.8557]
      },
      "properties": {
        "Type": "eDNA",
        "Device_ID": "eDNA-MER-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4865, 27.8562]
      },
      "properties": {
        "Type": "Soil Sensor",
        "Device_ID": "SS-MER-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4880, 27.8550]
      },
      "properties": {
        "Type": "Camera",
        "Device_ID": "CAM-MER-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4890, 27.8565]
      },
      "properties": {
        "Type": "BioAcoustic",
        "Device_ID": "AUD-MER-001"
      }
    }
  ]
};

export const Namsing_CR_Demarcation2025: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              95.48302829708254,
              27.92561290364955,
              0
            ],
            [
              95.48244287415314,
              27.92559447630006,
              0
            ],
            [
              95.48122818507812,
              27.92558355916054,
              0
            ],
            [
              95.48083129142978,
              27.92545010072228,
              0
            ],
            [
              95.48001754657292,
              27.92548310537624,
              0
            ],
            [
              95.47780992836013,
              27.92475543223482,
              0
            ],
            [
              95.47727764611841,
              27.92450311802376,
              0
            ],
            [
              95.47588080893833,
              27.9237519417014,
              0
            ],
            [
              95.4757645686528,
              27.92351719070649,
              0
            ],
            [
              95.4762338246868,
              27.92288401106232,
              0
            ],
            [
              95.47697899016124,
              27.92215431014541,
              0
            ],
            [
              95.47813869416687,
              27.92109544454167,
              0
            ],
            [
              95.47993105998351,
              27.91981934108392,
              0
            ],
            [
              95.48013061826734,
              27.91947211512912,
              0
            ],
            [
              95.48029382488974,
              27.91846395930839,
              0
            ],
            [
              95.48041592599198,
              27.91766918537385,
              0
            ],
            [
              95.4809688378378,
              27.91605909178086,
              0
            ],
            [
              95.48127501737633,
              27.91520809682605,
              0
            ],
            [
              95.48200090668986,
              27.91368686023048,
              0
            ],
            [
              95.48274780089787,
              27.91291275191661,
              0
            ],
            [
              95.48302815029548,
              27.91237566521811,
              0
            ],
            [
              95.48346270229926,
              27.90922042010484,
              0
            ],
            [
              95.4836917783121,
              27.90836426633628,
              0
            ],
            [
              95.48370004406395,
              27.90677780970489,
              0
            ],
            [
              95.48426726308938,
              27.90388906927147,
              0
            ],
            [
              95.48465710784977,
              27.902355759131,
              0
            ],
            [
              95.48484942545929,
              27.90206942120728,
              0
            ],
            [
              95.48433458150205,
              27.89971142915223,
              0
            ],
            [
              95.48410740965409,
              27.89826917912504,
              0
            ],
            [
              95.48399210788847,
              27.89692989210616,
              0
            ],
            [
              95.48403108060057,
              27.89567168514618,
              0
            ],
            [
              95.48393013606619,
              27.89457503566282,
              0
            ],
            [
              95.48369062603408,
              27.89283356208148,
              0
            ],
            [
              95.48349818961786,
              27.89089223320301,
              0
            ],
            [
              95.48313739556268,
              27.88916538498014,
              0
            ],
            [
              95.48422347046912,
              27.88852923248527,
              0
            ],
            [
              95.48647313436913,
              27.88952123563208,
              0
            ],
            [
              95.4873489922948,
              27.88996623665088,
              0
            ],
            [
              95.48899081231865,
              27.89050807881256,
              0
            ],
            [
              95.48985045314578,
              27.89094393786942,
              0
            ],
            [
              95.49320577266236,
              27.89208941022292,
              0
            ],
            [
              95.4937380712489,
              27.89285901538037,
              0
            ],
            [
              95.49423077174421,
              27.89471141347227,
              0
            ],
            [
              95.49372415305578,
              27.89749312685143,
              0
            ],
            [
              95.49427372461844,
              27.89964908650672,
              0
            ],
            [
              95.49398794021633,
              27.90197609144499,
              0
            ],
            [
              95.49355845516925,
              27.90318832645045,
              0
            ],
            [
              95.49334135391307,
              27.90456761574146,
              0
            ],
            [
              95.49192781659667,
              27.90943544574042,
              0
            ],
            [
              95.49097443385168,
              27.91219792969204,
              0
            ],
            [
              95.48971643805994,
              27.91664285333632,
              0
            ],
            [
              95.48926846842645,
              27.91838081349418,
              0
            ],
            [
              95.48716296455363,
              27.92132295809147,
              0
            ],
            [
              95.48586985498281,
              27.92243753531221,
              0
            ],
            [
              95.48404888785812,
              27.92370907207396,
              0
            ],
            [
              95.48346567086114,
              27.9247444717264,
              0
            ],
            [
              95.4831643640898,
              27.92523825485111,
              0
            ],
            [
              95.48302829708254,
              27.92561290364955,
              0
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Namsing Proxy",
        "tessellate": true
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4840, 27.9130]
      },
      "properties": {
        "Type": "eDNA",
        "Device_ID": "eDNA-NAM-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.48445, 27.9150]
      },
      "properties": {
        "Type": "Soil Sensor",
        "Device_ID": "SS-NAM-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4880, 27.9200]
      },
      "properties": {
        "Type": "Camera",
        "Device_ID": "CAM-NAM-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4850, 27.9220]
      },
      "properties": {
        "Type": "BioAcoustic",
        "Device_ID": "AUD-NAM-001"
      }
    }
  ]
};



export const PS0000111: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              87.32770141300006,
              24.210995739000055
            ],
            [
              87.32784723500004,
              24.21071392400006
            ],
            [
              87.32796224400005,
              24.21045060000006
            ],
            [
              87.32815903100004,
              24.210217385000078
            ],
            [
              87.32840061800005,
              24.209983521000026
            ],
            [
              87.32851892300005,
              24.210139191000053
            ],
            [
              87.32848127600005,
              24.21019132500004
            ],
            [
              87.32848503600007,
              24.21031765500004
            ],
            [
              87.32856575800008,
              24.21034628600006
            ],
            [
              87.32858950800005,
              24.210391541000035
            ],
            [
              87.32853618200005,
              24.210439661000066
            ],
            [
              87.32852294300005,
              24.210472803000073
            ],
            [
              87.32855320000004,
              24.21050526600004
            ],
            [
              87.32861998200008,
              24.210481119000065
            ],
            [
              87.32870111500006,
              24.210534433000078
            ],
            [
              87.32878135400006,
              24.21053682200005
            ],
            [
              87.32881979100006,
              24.210434804000045
            ],
            [
              87.32889104600008,
              24.210493410000026
            ],
            [
              87.32896763300005,
              24.210528433000036
            ],
            [
              87.32902055400007,
              24.210412614000063
            ],
            [
              87.32912343900006,
              24.210434804000045
            ],
            [
              87.32913512900006,
              24.210494905000076
            ],
            [
              87.32921752200008,
              24.21047006200007
            ],
            [
              87.32923529200008,
              24.210614015000033
            ],
            [
              87.32908924400004,
              24.21069099500005
            ],
            [
              87.32905970200005,
              24.210804219000067
            ],
            [
              87.32915414200005,
              24.210886216000063
            ],
            [
              87.32920287600007,
              24.210994096000036
            ],
            [
              87.32927784700007,
              24.210892698000066
            ],
            [
              87.32927260900004,
              24.210782161000054
            ],
            [
              87.32934882300003,
              24.21072949200004
            ],
            [
              87.32939252400007,
              24.21074959300006
            ],
            [
              87.32939485100007,
              24.210800378000044
            ],
            [
              87.32942688000009,
              24.21083696000005
            ],
            [
              87.32947959100005,
              24.21091716600006
            ],
            [
              87.32951691200003,
              24.210895470000025
            ],
            [
              87.32949085000007,
              24.21080274600007
            ],
            [
              87.32949490000004,
              24.21072415900005
            ],
            [
              87.32955316800007,
              24.21069784200006
            ],
            [
              87.32950578800006,
              24.21061615700006
            ],
            [
              87.32943596600006,
              24.210603540000022
            ],
            [
              87.32937404600005,
              24.210539776000076
            ],
            [
              87.32924236900004,
              24.21061684700004
            ],
            [
              87.32921996500005,
              24.210465466000073
            ],
            [
              87.32926464600007,
              24.210446527000045
            ],
            [
              87.32920850700003,
              24.21036915800005
            ],
            [
              87.32911419400006,
              24.210434471000042
            ],
            [
              87.32902310000009,
              24.210407984000028
            ],
            [
              87.32908498100005,
              24.21036119100006
            ],
            [
              87.32913403400005,
              24.21033349000004
            ],
            [
              87.32900270400006,
              24.210160104000067
            ],
            [
              87.32887114300007,
              24.210071088000063
            ],
            [
              87.32876898400008,
              24.210061299000074
            ],
            [
              87.32862222500006,
              24.210096761000045
            ],
            [
              87.32851351000005,
              24.210147697000025
            ],
            [
              87.32840416700003,
              24.20997512200006
            ],
            [
              87.32847445100003,
              24.20989843700005
            ],
            [
              87.32851270600008,
              24.20999494600005
            ],
            [
              87.32854585800004,
              24.20999467100006
            ],
            [
              87.32855742700008,
              24.20995713700006
            ],
            [
              87.32852723400003,
              24.209938720000025
            ],
            [
              87.32849071600003,
              24.209936776000063
            ],
            [
              87.32847947200008,
              24.20989247700004
            ],
            [
              87.32873756900005,
              24.209641463000025
            ],
            [
              87.32877487200005,
              24.209633705000044
            ],
            [
              87.32880612500009,
              24.209581712000045
            ],
            [
              87.32891575000008,
              24.209462477000045
            ],
            [
              87.32911224500003,
              24.209720153000035
            ],
            [
              87.32910030200009,
              24.20974294800004
            ],
            [
              87.32910565400005,
              24.209786872000052
            ],
            [
              87.32916842200007,
              24.209782404000066
            ],
            [
              87.32919550600008,
              24.209783251000033
            ],
            [
              87.32922802100006,
              24.20980743900003
            ],
            [
              87.32926115500004,
              24.20975818000005
            ],
            [
              87.32951840300007,
              24.210033988000077
            ],
            [
              87.32954612800006,
              24.210081305000074
            ],
            [
              87.32961117200006,
              24.21008782100006
            ],
            [
              87.32960913700003,
              24.210030957000072
            ],
            [
              87.32955030500005,
              24.209980305000045
            ],
            [
              87.32951384700004,
              24.21002729500003
            ],
            [
              87.32926525700003,
              24.209760380000034
            ],
            [
              87.32920549000005,
              24.209746128000063
            ],
            [
              87.32919787400004,
              24.20977705200005
            ],
            [
              87.32917061000006,
              24.209780382000076
            ],
            [
              87.32916552000006,
              24.20972172000006
            ],
            [
              87.32911707900007,
              24.209709847000056
            ],
            [
              87.32891311300006,
              24.209467979000067
            ],
            [
              87.32919570900003,
              24.209182275000046
            ],
            [
              87.32950484400004,
              24.208858767000038
            ],
            [
              87.32959900100008,
              24.20892665100007
            ],
            [
              87.32964273200008,
              24.20900247700007
            ],
            [
              87.32964654500006,
              24.209050340000033
            ],
            [
              87.32968171000005,
              24.20907426200006
            ],
            [
              87.32969191700005,
              24.209173684000064
            ],
            [
              87.32977204100007,
              24.20919585400003
            ],
            [
              87.32986037200004,
              24.209299169000076
            ],
            [
              87.32982977800003,
              24.209332844000073
            ],
            [
              87.32984397400008,
              24.209437914000034
            ],
            [
              87.32988517800004,
              24.20949076000005
            ],
            [
              87.32994261100004,
              24.209468595000033
            ],
            [
              87.32988894600004,
              24.20952469100007
            ],
            [
              87.32973926600005,
              24.20954678000004
            ],
            [
              87.32956890400004,
              24.209465218000048
            ],
            [
              87.32930793100007,
              24.209667359000036
            ],
            [
              87.32947018200008,
              24.209807370000078
            ],
            [
              87.32960930600007,
              24.20979062600003
            ],
            [
              87.32962752600008,
              24.209887477000052
            ],
            [
              87.32972451400008,
              24.209895911000046
            ],
            [
              87.32980199400004,
              24.20994433800007
            ],
            [
              87.32990414600005,
              24.209960505000026
            ],
            [
              87.32999261700007,
              24.210023123000042
            ],
            [
              87.33015776200006,
              24.209930625000027
            ],
            [
              87.33018343200007,
              24.209863184000028
            ],
            [
              87.33025700200005,
              24.209871830000054
            ],
            [
              87.33030532800007,
              24.20990460400003
            ],
            [
              87.33036086500005,
              24.209964160000027
            ],
            [
              87.33041056500008,
              24.209976392000044
            ],
            [
              87.33041632800007,
              24.210098516000073
            ],
            [
              87.33037177700004,
              24.210167928000033
            ],
            [
              87.33027677000007,
              24.21039187300005
            ],
            [
              87.33053141900007,
              24.210756418000074
            ],
            [
              87.33029188900008,
              24.210944510000047
            ],
            [
              87.33028807400007,
              24.210759562000078
            ],
            [
              87.33018452900006,
              24.210602736000055
            ],
            [
              87.32998893600006,
              24.210672548000048
            ],
            [
              87.32989500600007,
              24.210750951000023
            ],
            [
              87.32981134400006,
              24.210853229000065
            ],
            [
              87.32978531700007,
              24.21097823200006
            ],
            [
              87.32981073200006,
              24.211097120000034
            ],
            [
              87.32989824600008,
              24.211153204000027
            ],
            [
              87.33000757000008,
              24.21110952300006
            ],
            [
              87.32997527800006,
              24.211044558000026
            ],
            [
              87.32995471900006,
              24.210958042000073
            ],
            [
              87.32990300900008,
              24.210955616000035
            ],
            [
              87.32989576600005,
              24.21089360600007
            ],
            [
              87.33006415300008,
              24.210985901000072
            ],
            [
              87.33015810200004,
              24.210939565000047
            ],
            [
              87.33029663800005,
              24.21077175100004
            ],
            [
              87.33029985000007,
              24.210966992000067
            ],
            [
              87.33016842400008,
              24.211197584000047
            ],
            [
              87.33016891500006,
              24.211336174000053
            ],
            [
              87.33017528700003,
              24.211434215000054
            ],
            [
              87.33004406300006,
              24.21125046700007
            ],
            [
              87.32983974700005,
              24.211312709000026
            ],
            [
              87.32982853000004,
              24.21142238300007
            ],
            [
              87.32996323600008,
              24.211558040000057
            ],
            [
              87.33005908800004,
              24.211512010000035
            ],
            [
              87.33005333600005,
              24.211253971000076
            ],
            [
              87.33018199700007,
              24.211430880000023
            ],
            [
              87.33014923300004,
              24.211621794000052
            ],
            [
              87.33009595100003,
              24.211625757000036
            ],
            [
              87.33001086300004,
              24.211699860000067
            ],
            [
              87.32992476100009,
              24.211699176000025
            ],
            [
              87.32982523800007,
              24.211630899000056
            ],
            [
              87.32971423000004,
              24.211582209000028
            ],
            [
              87.32970066500008,
              24.211508991000073
            ],
            [
              87.32966960400006,
              24.21145044800005
            ],
            [
              87.32969102900006,
              24.211377768000034
            ],
            [
              87.32962369700005,
              24.211359170000037
            ],
            [
              87.32959760900007,
              24.21141010900004
            ],
            [
              87.32962488500004,
              24.21142973900004
            ],
            [
              87.32965955200007,
              24.211475799000027
            ],
            [
              87.32965365800004,
              24.211515692000035
            ],
            [
              87.32966920000007,
              24.211533702000054
            ],
            [
              87.32965403500003,
              24.21157034500004
            ],
            [
              87.32968918500006,
              24.211583621000045
            ],
            [
              87.32981188700006,
              24.21161655000003
            ],
            [
              87.32978251400004,
              24.211670283000046
            ],
            [
              87.32970887300007,
              24.211705993000066
            ],
            [
              87.32960785900008,
              24.21166068100007
            ],
            [
              87.32927090100009,
              24.211660903000052
            ],
            [
              87.32911447200007,
              24.211660090000066
            ],
            [
              87.32893643500006,
              24.21176899200003
            ],
            [
              87.32877803100007,
              24.21172890300005
            ],
            [
              87.32867290400009,
              24.21180978600006
            ],
            [
              87.32836311500006,
              24.21179666000006
            ],
            [
              87.32825323100008,
              24.211902863000034
            ],
            [
              87.32806223900008,
              24.21178530000003
            ],
            [
              87.32809874600008,
              24.21170230300004
            ],
            [
              87.32772888800008,
              24.211547402000065
            ],
            [
              87.32761690700005,
              24.211560182000028
            ],
            [
              87.32770141300006,
              24.210995739000055
            ]
          ]
        ]
      },
      "properties": {
        "Name": "PS0000111",
        "FolderPath": "PS0000111.kmz",
        "SymbolID": 0,
        "AltMode": 0,
        "Base": 0,
        "Clamped": -1,
        "Extruded": 0,
        "Snippet": null,
        "PopupInfo": null,
        "Shape_Leng": 0.0232574987257,
        "Shape_Area": 0.000004463919791
      }
    }
  ]
};


export const Paglam_CR_Demarcation2025: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              95.4938796156162,
              27.83197224943551,
              0
            ],
            [
              95.49218730047394,
              27.83212191560334,
              0
            ],
            [
              95.49162580699746,
              27.83211992308398,
              0
            ],
            [
              95.4913133193842,
              27.8321623444149,
              0
            ],
            [
              95.49056549527181,
              27.83240630419374,
              0
            ],
            [
              95.48888598201782,
              27.83186282508742,
              0
            ],
            [
              95.48763921761594,
              27.83155959262853,
              0
            ],
            [
              95.48688449764853,
              27.8314876933217,
              0
            ],
            [
              95.4864119916221,
              27.83168515413482,
              0
            ],
            [
              95.48620368699272,
              27.83049376586332,
              0
            ],
            [
              95.4860106124425,
              27.829297038202,
              0
            ],
            [
              95.48581694672156,
              27.82833914911997,
              0
            ],
            [
              95.48545769941093,
              27.82699309200502,
              0
            ],
            [
              95.48528672361617,
              27.82548350714098,
              0
            ],
            [
              95.48456179927402,
              27.82455113406673,
              0
            ],
            [
              95.48423740637891,
              27.82354719802196,
              0
            ],
            [
              95.48369434669725,
              27.8224643218198,
              0
            ],
            [
              95.4832507991388,
              27.82126993875053,
              0
            ],
            [
              95.48280481781362,
              27.82017868908525,
              0
            ],
            [
              95.48223421503083,
              27.81768921396797,
              0
            ],
            [
              95.48292624146187,
              27.81713561580341,
              0
            ],
            [
              95.48418080401763,
              27.81600897542372,
              0
            ],
            [
              95.48502476497316,
              27.81492702284337,
              0
            ],
            [
              95.48658165577332,
              27.81404460291004,
              0
            ],
            [
              95.4877333607645,
              27.81310890162883,
              0
            ],
            [
              95.49118700270276,
              27.81433944994826,
              0
            ],
            [
              95.49243128238797,
              27.8147189695033,
              0
            ],
            [
              95.49368187587734,
              27.81523252064106,
              0
            ],
            [
              95.49559922737134,
              27.8156389354594,
              0
            ],
            [
              95.4968784142648,
              27.81656839695146,
              0
            ],
            [
              95.49848161150632,
              27.81711993128963,
              0
            ],
            [
              95.50265313780048,
              27.81993632974827,
              0
            ],
            [
              95.50368097229887,
              27.82130725267815,
              0
            ],
            [
              95.50322692297145,
              27.82286272073013,
              0
            ],
            [
              95.50275779562533,
              27.82300922192951,
              0
            ],
            [
              95.50214204916914,
              27.82299952412808,
              0
            ],
            [
              95.5009675655997,
              27.82312399117663,
              0
            ],
            [
              95.49984698154951,
              27.82321438414582,
              0
            ],
            [
              95.49866531523543,
              27.82336057264519,
              0
            ],
            [
              95.49788159673565,
              27.82340716155245,
              0
            ],
            [
              95.49700165866268,
              27.82363478702657,
              0
            ],
            [
              95.49652206886194,
              27.82350170980898,
              0
            ],
            [
              95.49601936103913,
              27.82349817659547,
              0
            ],
            [
              95.49523199626687,
              27.82363840105887,
              0
            ],
            [
              95.49467177376287,
              27.82405632469508,
              0
            ],
            [
              95.49438325721542,
              27.82444345393158,
              0
            ],
            [
              95.49446713917105,
              27.82496583657187,
              0
            ],
            [
              95.4948458869529,
              27.82545552616188,
              0
            ],
            [
              95.49535493143891,
              27.82614817764293,
              0
            ],
            [
              95.4953702661373,
              27.82665202834857,
              0
            ],
            [
              95.49492503205286,
              27.82781257187251,
              0
            ],
            [
              95.49486205752243,
              27.82850214363632,
              0
            ],
            [
              95.49485802106054,
              27.82909551297508,
              0
            ],
            [
              95.49474031982874,
              27.82988589328832,
              0
            ],
            [
              95.49439731441308,
              27.83068933359296,
              0
            ],
            [
              95.49414996178149,
              27.8313209511526,
              0
            ],
            [
              95.49394286584321,
              27.83181170005121,
              0
            ],
            [
              95.4938796156162,
              27.83197224943551,
              0
            ]
          ]
        ]
      },
      "properties": {
        "Name": "Paglam",
        "tessellate": true
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4913, 27.8221]
      },
      "properties": {
        "Type": "eDNA",
        "Device_ID": "eDNA-PAG-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4935, 27.8235]
      },
      "properties": {
        "Type": "Soil Sensor",
        "Device_ID": "SS-PAG-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4950, 27.8180]
      },
      "properties": {
        "Type": "Camera",
        "Device_ID": "CAM-PAG-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4980, 27.8200]
      },
      "properties": {
        "Type": "BioAcoustic",
        "Device_ID": "AUD-PAG-001"
      }
    }
  ]
};

export const PS0000149: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3348, 24.4106]
      },
      "properties": {
        "Type": "Soil Sensor",
        "Device_ID": "SS-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3350, 24.4105]
      },
      "properties": {
        "Type": "Camera",
        "Device_ID": "CAM-003"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3351, 24.4110]
      },
      "properties": {
        "Type": "BioAcoustic",
        "Device_ID": "AUD-004"
      }
    },
    {
      "type": "Feature",
      "properties": { "Name": "PS0000149", "Type": "Restoration", "Area": "0.207 ha", "ID": "PS149" },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [87.334572434, 24.410446919],
          [87.334472469, 24.410464682],
          [87.334520871, 24.410574146],
          [87.334705368, 24.410761672],
          [87.334975353, 24.410872201],
          [87.335140078, 24.411164754],
          [87.335291152, 24.411107663],
          [87.335112281, 24.410919391],
          [87.335180402, 24.410495453],
          [87.334703811, 24.410463873],
          [87.334572434, 24.410446919]
        ]]
      }
    }
  ]
};


export const PS000060: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.4518, 24.2100]
      },
      "properties": {
        "Type": "Soil Sensor",
        "Device_ID": "SS-002"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.4520, 24.2102]
      },
      "properties": {
        "Type": "Camera",
        "Device_ID": "CAM-002"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.4508, 24.2092]
      },
      "properties": {
        "Type": "BioAcoustic",
        "Device_ID": "AUD-002"
      }
    },
    {
      "type": "Feature",
      "properties": { "Name": "PS000060", "Type": "Restoration", "Area": "4.42 ha", "ID": "PS060" },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[87.452016295, 24.210309187], [87.45300974, 24.209554817], [87.452992813, 24.209499199], [87.452992439, 24.209233937], [87.452856986, 24.209197011], [87.452860914, 24.209147073], [87.452921464, 24.209066551], [87.452966221, 24.209014153], [87.452952691, 24.208897749], [87.452869132, 24.208841975], [87.452468221, 24.208851608], [87.452345922, 24.208914345], [87.451907785, 24.20885247], [87.451493102, 24.208787854], [87.45127049, 24.208759425], [87.451189177, 24.20877556], [87.450945808, 24.208694202], [87.450786692, 24.208728278], [87.450516855, 24.208792804], [87.450489371, 24.208969801], [87.450533676, 24.209123282], [87.450581343, 24.209302021], [87.450541753, 24.209428631], [87.450398472, 24.209493406], [87.450464, 24.209827], [87.450554913, 24.210154952], [87.450765417, 24.211039471], [87.451400693, 24.2109008], [87.451459932, 24.210739273], [87.451494768, 24.210637932], [87.451625316, 24.210555718], [87.451721921, 24.210556032], [87.451759339, 24.210346157], [87.452016295, 24.210309187]]]
      }
    }
  ]
};

export const PS0000107: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3890, 24.1923]
      },
      "properties": {
        "Type": "Soil Sensor",
        "Device_ID": "SS-003"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3888, 24.1924]
      },
      "properties": {
        "Type": "Camera",
        "Device_ID": "CAM-003"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3884, 24.1926]
      },
      "properties": {
        "Type": "BioAcoustic",
        "Device_ID": "AUD-003"
      }
    },
    {
      "type": "Feature",
      "properties": { "Name": "PS0000107", "Type": "Restoration", "Area": "0.74 ha", "ID": "PS107" },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[87.389447425, 24.192244862], [87.38939655, 24.19215299], [87.389336016, 24.19217408], [87.38927312, 24.192220165], [87.389208823, 24.192180183], [87.389138903, 24.192132618], [87.389114182, 24.19208798], [87.389038348, 24.192158388], [87.389078707, 24.192259795], [87.389061385, 24.192326152], [87.38901222, 24.192292297], [87.388975777, 24.192122318], [87.388894816, 24.192187124], [87.388822796, 24.192304505], [87.388720541, 24.192334576], [87.388758133, 24.192402453], [87.388610419, 24.192481111], [87.388495621, 24.192537832], [87.388368955, 24.19262577], [87.388290519, 24.192482262], [87.388145454, 24.192372011], [87.387995369, 24.192426356], [87.387940145, 24.192414634], [87.387926054, 24.192346674], [87.387734493, 24.192440967], [87.387836805, 24.192577884], [87.38800005, 24.192536576], [87.388162861, 24.192744627], [87.3880208, 24.192885145], [87.388187586, 24.19303878], [87.388302376, 24.193010233], [87.388407399, 24.192958793], [87.388465298, 24.192919725], [87.388400562, 24.192847345], [87.388416682, 24.192780723], [87.388509317, 24.192830825], [87.388462216, 24.19291586], [87.388688943, 24.192989199], [87.388792315, 24.192951293], [87.388727271, 24.192883638], [87.388692786, 24.192759498], [87.388708589, 24.192544421], [87.388712199, 24.192459357], [87.388849859, 24.192475026], [87.388963148, 24.192405809], [87.389071527, 24.192611364], [87.38918391, 24.192625834], [87.389218195, 24.19268641], [87.389268756, 24.192665128], [87.38935248, 24.192615312], [87.38939196, 24.192685511], [87.38951396, 24.192684985], [87.389603564, 24.192650026], [87.389563775, 24.192346247], [87.389518207, 24.192307214], [87.389544328, 24.192235751], [87.389447425, 24.192244862]]]
      }
    }
  ]
};

export const PS0000139: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3922, 24.1718]
      },
      "properties": {
        "Type": "Soil Sensor",
        "Device_ID": "SS-004"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3922, 24.1722]
      },
      "properties": {
        "Type": "Camera",
        "Device_ID": "CAM-004"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3925, 24.1725]
      },
      "properties": {
        "Type": "BioAcoustic",
        "Device_ID": "AUD-004"
      }
    },
    {
      "type": "Feature",
      "properties": { "Name": "PS0000139", "Type": "Restoration", "Area": "2.59 ha", "ID": "PS139" },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[87.391983372, 24.1721668], [87.391951374, 24.172268777], [87.392375299, 24.172647585], [87.392699445, 24.172541558], [87.392901284, 24.172523308], [87.393001843, 24.17266109], [87.392928986, 24.172726253], [87.393300444, 24.173274751], [87.393574148, 24.173096466], [87.393470742, 24.172708668], [87.393210286, 24.172399364], [87.392922201, 24.172122862], [87.392607653, 24.171764594], [87.392355256, 24.171485486], [87.392243571, 24.171237881], [87.391419915, 24.170142339], [87.39114254, 24.170216309], [87.390004995, 24.17008098], [87.390878152, 24.170124973], [87.390942616, 24.170302418], [87.390951487, 24.170492007], [87.391307892, 24.170951738], [87.391348195, 24.171146259], [87.391428887, 24.171422624], [87.391551683, 24.171638554], [87.391765799, 24.171611931], [87.391983372, 24.1721668]]]
      }
    }
  ]
};

export const PS0000132: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3223, 24.5650]
      },
      "properties": {
        "Type": "Soil Sensor",
        "Device_ID": "SS-005"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3220, 24.5648]
      },
      "properties": {
        "Type": "Camera",
        "Device_ID": "CAM-005"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [87.3215, 24.5648]
      },
      "properties": {
        "Type": "BioAcoustic",
        "Device_ID": "AUD-005"
      }
    },
    {
      "type": "Feature",
      "properties": { "Name": "PS0000132", "Type": "Restoration", "Area": "2.49 ha", "ID": "PS132" },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[87.322352117, 24.564470281], [87.322237143, 24.56450339], [87.321960435, 24.564646827], [87.321685567, 24.564633283], [87.321588033, 24.564601962], [87.321301451, 24.564463448], [87.320942898, 24.564383106], [87.32082, 24.564383], [87.321658, 24.565335], [87.322271, 24.565777], [87.322293389, 24.56579426], [87.322353178, 24.565799947], [87.322403844, 24.56579379], [87.322463431, 24.565796059], [87.322483956, 24.565773633], [87.322522562, 24.565764236], [87.322545345, 24.565740822], [87.322585122, 24.56573505], [87.322664317, 24.565708548], [87.322704105, 24.565702847], [87.322738172, 24.565700468], [87.322699741, 24.56563644], [87.322727017, 24.565611215], [87.322767013, 24.565665515], [87.32284908, 24.565744863], [87.322883051, 24.565760665], [87.322934478, 24.565787601], [87.323074482, 24.565681761], [87.323054836, 24.565627226], [87.323082391, 24.565629136], [87.32321815, 24.565470169], [87.323206525, 24.565442208], [87.323329993, 24.56531067], [87.323300279, 24.565271732], [87.323262529, 24.56525596], [87.323267008, 24.565230954], [87.323249324, 24.565213135], [87.323218716, 24.565248644], [87.323216562, 24.565216594], [87.323182436, 24.565216503], [87.32314203, 24.565229394], [87.323158453, 24.565195257], [87.323154158, 24.565174186], [87.323190339, 24.565160256], [87.323228144, 24.565160306], [87.323270603, 24.565180233], [87.323539317, 24.565040531], [87.323596742, 24.565004271], [87.323635748, 24.56500329], [87.323764825, 24.564927271], [87.323699065, 24.564807561], [87.323656801, 24.564791846], [87.323612634, 24.564768304], [87.323617658, 24.564787834], [87.32360972, 24.564816425], [87.323594367, 24.564795486], [87.323563729, 24.564801777], [87.323531426, 24.564798956], [87.323530876, 24.564779498], [87.323569869, 24.564761577], [87.32355177, 24.564743353], [87.323508821, 24.564774183], [87.323515624, 24.564810517], [87.323483838, 24.564833561], [87.323444431, 24.564837077], [87.323426534, 24.564814946], [87.32341286, 24.564783878], [87.323412236, 24.56475168], [87.323394792, 24.564724637], [87.323361296, 24.564694435], [87.323350525, 24.564662548], [87.323326312, 24.564642427], [87.323294038, 24.564654229], [87.323280418, 24.564679387], [87.323263926, 24.564645901], [87.322271, 24.565777], [87.322381479, 24.564495097], [87.322352117, 24.564470281]]]
      }
    }
  ]
};

export const SHIVGURI_CR_Demarcation2025: FeatureCollection<Geometry> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "Name": "Shivguri"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [95.4707, 27.8268],
            [95.4717, 27.8278],
            [95.4727, 27.8268],
            [95.4717, 27.8258],
            [95.4707, 27.8268]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4719, 27.8269]
      },
      "properties": {
        "Type": "eDNA",
        "Device_ID": "eDNA-SHI-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4712, 27.8265]
      },
      "properties": {
        "Type": "Soil Sensor",
        "Device_ID": "SS-SHI-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4716, 27.8273]
      },
      "properties": {
        "Type": "Camera",
        "Device_ID": "CAM-SHI-001"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [95.4714, 27.8275]
      },
      "properties": {
        "Type": "BioAcoustic",
        "Device_ID": "AM-SHI-001"
      }
    }
  ]
};



